module.exports = __webpack_public_path__ + "biologic-2.png";